import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './utils/logger'; // initialize logger and patch console early
import './utils/patchGetUserMedia'; // patch getUserMedia early for stability
import App from './App';
import './i18n';
import './styles/global.css';
import ErrorBoundary from './components/common/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <Router>
      <App />
    </Router>
  </ErrorBoundary>
);